import { render, staticRenderFns } from "./AvatarCard.vue?vue&type=template&id=00dbbcea&scoped=true&lang=pug"
import script from "./AvatarCard.vue?vue&type=script&lang=ts"
export * from "./AvatarCard.vue?vue&type=script&lang=ts"
import style0 from "./AvatarCard.vue?vue&type=style&index=0&id=00dbbcea&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dbbcea",
  null
  
)

export default component.exports